export default {
  setCountries (state, payload) {
    state.countries = payload
  },
  setSelectedCountries (state, payload) {
    state.selectedCountries = payload
  },
  addSelectedCountry (state, payload) {
    if (state.selectedCountries.some(item => item.id === payload.id)) {
      // do nothing
    } else {
      state.selectedCountries.push(payload)
    }
  },
  removeSelectedCountry (state, payload) {
    state.selectedCountries.splice(state.selectedCountries.indexOf(payload), 1)
  },
  setStates (state, payload) {
    state.states = payload
  },
  setSelectedStates (state, payload) {
    state.selectedStates = payload
  },
  addSelectedState (state, payload) {
    if (state.selectedStates.some(item => item.id === payload.id)) {
      // do nothing
    } else {
      state.selectedStates.push(payload)
    }
  },
  removeSelectedState (state, payload) {
    state.selectedStates.splice(state.selectedStates.indexOf(payload), 1)
  },
  setCities (state, payload) {
    state.cities = payload
  },
  setSelectedCities (state, payload) {
    state.selectedCities = payload
  },
  addSelectedCity (state, payload) {
    if (state.selectedCities.some(item => item.id === payload.id)) {
      // do nothing
    } else {
      state.selectedCities.push(payload)
    }
  },
  removeSelectedCity (state, payload) {
    state.selectedCities.splice(state.selectedCities.indexOf(payload), 1)
  },
  setLanguages (state, payload) {
    state.languages = payload
  },
  setSelectedLanguages (state, payload) {
    state.selectedLanguages = payload
  },
  addSelectedLanguage (state, payload) {
    if (state.selectedLanguages.some(item => item.id === payload.id)) {
      // do nothing
    } else {
      state.selectedLanguages.push(payload)
    }
  },
  removeSelectedLanguage (state, payload) {
    state.selectedLanguages.splice(state.selectedLanguages.indexOf(payload), 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js